import React, { useState } from 'react';
import FilterButton from '../../../components/FilterModal/FilterButton';
import LocationFilterModalSingleSelect from '../../../components/FilterModal/LocationFilterModalSingleSelect';
import { EditIcon } from '../../../components/Icon';

export default function SelectLocation({
  selectItem,
  selectedItem,
  isForAppFeed = false,
}) {
  const [isLocationFilterModalOpen, setIsLocationFilterModalOpen] =
    useState(false);
  function handleSave(location) {
    selectItem(location);
    setIsLocationFilterModalOpen(false);
  }
  return (
    <>
      <FilterButton
        setIsOpen={setIsLocationFilterModalOpen}
        message={
          isForAppFeed &&
          (selectedItem?.display_name || selectedItem?.business_name) ? (
            <>
              {selectedItem.display_name || selectedItem.business_name}{' '}
              <EditIcon />
            </>
          ) : (
            'Select Location'
          )
        }
        height='55px'
        preventDefault={true}
      />

      {isLocationFilterModalOpen && (
        <LocationFilterModalSingleSelect
          isOpen={isLocationFilterModalOpen}
          setIsOpen={setIsLocationFilterModalOpen}
          // locationList
          //   requestParams
          //   placeholder
          //   searchLabel
          //   requestingGetBusinessLocationsOfMerchant
          //   updateLocationRequestParams
          approveButtonName='Select Business'
          handleSave={handleSave}
          initialBusiness={selectedItem}
          //   getBusinessLocations
          //   getBusinessLocationsOfMerchant
        />
      )}
    </>
  );
}
